import HttpService from './baseHttp'

//Download测算
export const HttpDownloadCalc = (data = {}) => HttpService.post("/api/v2/carrierCalculation/skuExport", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//包裹运费测算
export const HttpPackageCalc = (data = {}) => HttpService.post("/api/v2/carrierCalculation/packageCalculation", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_SHIP });

//成本测算
export const HttpCostCalc = (data = {}) => HttpService.post("/api/v2/costSettlement/packageCalculation", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 成本测算销售订单
export const HttpCostOrderList = (data = {}) => HttpService.get("/api/v2/saleOrder/costFindByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// /api/v2/saleOrder/costFindByPage

// 根据系统仓查询地址
export const HttpSYSAddress = (data = {}) => HttpService.get("/api/v2/address/findAddressesOfWarehouseId", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 根据订单号查询收货地址
export const HttpResiveAddress = (data = {}) => HttpService.get("/api/v2/saleOrder/costFindOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 根据组织请求对应的可用仓库
export const HttpFindOrgCorrespWare = (data = {}) => HttpService.get("/api/v2/organizationWarehouse/findAllByOrgId", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });



//销售订单运费测算
export const HttpOrderCalc = (data = {}) => HttpService.post("/api/v2/carrierCalculation/orderCalculation", data, { baseURL: process.env.VUE_APP_APIURL_SHIP });
//sku运费测算
export const HttpSkuCalc = (data = {}) => HttpService.post("/api/v2/carrierCalculation/skuCalculation", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_SHIP });
//Fedex地址验证
export const HttpCheckAddress = (data = {}) => HttpService.post("/api/v2/carrierCalculation/checkAddress", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//附加规则数据复制
export const HttpCopyAddonRule = (data = {}) => HttpService.post("/api/v2/carrierAddonRule/copyRule", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//附加规则数据删除
export const HttpDelAddonRule = (data = {}) => HttpService.get("/api/v2/carrierAddonRule/deleteById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//附加规则数据批量删除
// export const HttpDelAddonRuleList = (data = {}) => HttpService.get("/api/v2/carrierAddonRule/deleteByIds", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//附加规则数据保存
export const HttpSaveAddonRule = (data = {}) => HttpService.post("/api/v2/carrierAddonRule/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//附加规则单条查询
export const HttpAddonRule = (data = {}) => HttpService.get("/api/v2/carrierAddonRule/findById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//附加规则分页查询
export const HttpAddonRuleList = (data = {}) => HttpService.get("/api/v2/carrierAddonRule/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//限制规则数据复制
export const HttpCopyRule = (data = {}) => HttpService.post("/api/v2/carrierRestrictRule/copyRule", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//限制规则数据删除
export const HttpDelRule = (data = {}) => HttpService.get("/api/v2/carrierRestrictRule/deleteById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//限制规则数据保存
export const HttpSaveRule = (data = {}) => HttpService.post("/api/v2/carrierRestrictRule/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//限制规则单条查询
export const HttpRule = (data = {}) => HttpService.get("/api/v2/carrierRestrictRule/findById", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//限制规则分页查询
export const HttpRuleList = (data = {}) => HttpService.get("/api/v2/carrierRestrictRule/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//销售订单测算 分页查询
export const HttpOrderList = (data = {}) => HttpService.get("/api/v2/B2cOrder/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });


// Fedex运费成本配置
// 成本基础费用列表
export const HttpGetBaseCostList = (data = {}) => HttpService.get("/api/v2/fedexBaseCost/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条删除
export const HttpDeleteBaseCostOne = (data = {}) => HttpService.get("/api/v2/fedexBaseCost/deleteOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询
export const HttpGetBaseCostOne = (data = {}) => HttpService.get("/api/v2/fedexBaseCost/findByOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条保存
export const HttpSaveBaseCostOne = (data = {}) => HttpService.post("/api/v2/fedexBaseCost/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取历史记录
export const HttpGetLog = (data = {}) => HttpService.get("/api/v2/FbbOpLog/findByModule", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


// 成本附加规则列表
export const HttpGetAdditionalRulesList = (data = {}) => HttpService.get("/api/v2/fedexCostAddRule/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条删除
export const HttpDeleteAdditionalRulesOne = (data = {}) => HttpService.get("/api/v2/fedexCostAddRule/deleteOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询
export const HttpGetAdditionalRulesOne = (data = {}) => HttpService.get("/api/v2/fedexCostAddRule/findByOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条保存
export const HttpSaveAdditionalRulesOne = (data = {}) => HttpService.post("/api/v2/fedexCostAddRule/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });


// 成本折扣率列表
export const HttpGetDisCountList = (data = {}) => HttpService.get("/api/v2/fedexCostDiscount/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条删除
export const HttpDeleteDisCountOne = (data = {}) => HttpService.get("/api/v2/fedexCostDiscount/deleteOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询
export const HttpGetDisCountOne = (data = {}) => HttpService.get("/api/v2/fedexCostDiscount/findByOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条保存
export const HttpSaveDisCountOne = (data = {}) => HttpService.post("/api/v2/fedexCostDiscount/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });


// FedEx运费成本配置 / 成本最低收费
// 成本最低收费分页
export const HttpMinCostList = (data = {}) => HttpService.get("/api/v2/fedexMinCost/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 成本最低收费单条查询
export const HttpMinCost = (data = {}) => HttpService.get("/api/v2/fedexMinCost/findByOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 成本最低收费条件导出
export const HttpExportMinCosts = (data = {}, config = {}) => HttpService.get("/api/v2/fedexMinCost/export", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB, ...config });
// 成本最低收费单条删除
export const HttpDelMinCost = (data = {}) => HttpService.get("/api/v2/fedexMinCost/deleteOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 成本最低收费单条保存
export const HttpSaveMinCost = (data = {}) => HttpService.post("/api/v2/fedexMinCost/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });



// FedEx账单导入
// 列表查询
export const HttpBillImportList = (data = {}) => HttpService.get("/api/v2/billImport/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询
export const HttpBillImportOne = (data = {}) => HttpService.get("/api/v2/billImport/findByOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 账单导入明细
export const HttpImportItem = (data = {}) => HttpService.get("/api/v2/billItem/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });



// FedEx账单导入处理
// 列表查询
export const HttpBillImportDetailList = (data = {}) => HttpService.get("/api/v2/billDeal/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询
export const HttpBillImportDetailOne = (data = {}) => HttpService.get("/api/v2/billDeal/findByOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 导出
export const HttpBillImportDetailExport = (data = {}, config = {}) => HttpService.get("/api/v2/billDeal/export", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB, ...config });
// 添加编辑
export const HttpUpdateDetail = (data = {}) => HttpService.post("/api/v2/billDeal/update", data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 成本核算
// 列表
export const HttpCostCheckList = (data = {}) => HttpService.get("/api/v2/costSettlement/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 重处理
export const HttpCostCheckReDetail = (data = {}) => HttpService.get("/api/v2/costSettlement/reSettlement", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 成本费用明细
// 列表
export const HttpCostDetailList = (data = {}) => HttpService.get("/api/v2/costSettlement/item/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });



// FedEx运费核算
// 列表
export const HttpSettlementList = (data = {}) => HttpService.get("/api/v2/freightSettlement/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询
export const HttpSettlementOne = (data = {}) => HttpService.get("/api/v2/freightSettlement/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条编辑
export const HttpEditSettlement = (data = {}) => HttpService.post("/api/v2/freightSettlement/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 批量结算
export const HttpBatchSettlement = (data = {}) => HttpService.post("/api/v2/freightSettlement/batchSettlement", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 撤销结算
export const HttpBatchRevoke = (data = {}) => HttpService.post("/api/v2/freightSettlement/batchRevoke", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 批量撤销结算
export const HttpBatchRevokeAll = (data = {}) => HttpService.post("/api/v2/freightSettlement/lotBatchRevoke", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 按日期结算
export const HttpDaySettlement = (data = {}) => HttpService.get("/api/v2/freightSettlement/daySettlement", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 无需结算
export const HttpNoSettlement = (data = {}) => HttpService.post("/api/v2/freightSettlement/noSettlement", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查询费用明细
export const HttpSettlementCostDetail = (data = {}) => HttpService.get("/api/v2/freightSettlement/item/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 状态异常时查询费用明细
export const HttpSettlementCostDetailError = (data = {}) => HttpService.get("/api/v2/freightSettlement/findErrorItemByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });



//Fedex运费结算明细
// 列表
export const HttpSettlementDetailList = (data = {}) => HttpService.get("/api/v2/freightSettlement/item/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


// Fedex运费对比概览
export const HttpAnalyzeCompare = (data = {}) => HttpService.get("/api/v2/comparison/fedexBillComparison", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpAnalyzeRange = (data = {}) => HttpService.get("/api/v2/comparison/monthCost", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


// FedEx运费对比明细
// 总费用对比
export const HttpAnalyzeDetailAll = (data = {}) => HttpService.get("/api/v2/expensesComparison/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 费用对比
export const HttpHttpAnalyzeDetailOne = (data = {}) => HttpService.get("/api/v2/expensesComparisonDetailed/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


// Fedex运费包裹数据对比
export const HttpHttPackageList = (data = {}) => HttpService.get("/api/v2/packageComparison/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 导出
export const HttpPackageExport = (data, config) => HttpService.get('/api/v2/packageComparison/export', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB, ...config });


// 结算carrie配置
export const HttpCarrierList = (data = {}) => HttpService.get("/api/v2/settlementCarrier/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询
export const HttpCarrierOne = (data = {}) => HttpService.get("/api/v2/settlementCarrier/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 保存数据
export const HttpCarrierSave = (data, config) => HttpService.post('/api/v2/settlementCarrier/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 复制规则
export const HttpCarrierCopy = (data = {}) => HttpService.get("/api/v2/settlementCarrier/copyRule", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条删除
export const HttpInvaildCarrierOne = (data = {}) => HttpService.get("/api/v2/settlementCarrier/delete", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条改变状态
export const HttpChangeCarrierOne = (data = {}) => HttpService.get("/api/v2/settlementCarrier/status", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });



// oversize规则配置
export const HttpOversizeList = (data = {}) => HttpService.get("/api/v2/oversizeRule/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询
export const HttpOversizeOne = (data = {}) => HttpService.get("/api/v2/oversizeRule/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 保存数据
export const HttpOversizeSave = (data, config) => HttpService.post('/api/v2/oversizeRule/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条删除
export const HttpDeleteOversizeOne = (data = {}) => HttpService.get("/api/v2/oversizeRule/delete", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


// 账单导入的无需处理和重处理
export const HttpNoNeedBilling = (data = {}) => HttpService.post("/api/v2/billDeal/noNeedBilling", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpReProcessBilling = (data = {}) => HttpService.post("/api/v2/billDeal/reprocess", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 保存费用明细
export const HttpConfirmSettlementCost = (data, config) => HttpService.post('/api/v2/freightSettlement/confirmSettlementCost', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 保存费用明细异常
export const HttpConfirmSettlementCostError = (data, config) => HttpService.post('/api/v2/freightSettlement/confirmErrorSettlementCost', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });

// 根据组织id查询物流产品
export const HttpGetServiceList = (data = {}) => HttpService.get("/api/v2/sysCarrierGroup/findByCustomerId", { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP });
// 根据物流产品查询物流产品服务
export const HttpGetServiceProductList = (data = {}) => HttpService.get("/api/v2/carrierGroupServiceCode/findByGroupId", { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP });
// 获取所有物流产品
export const HttpGetAllServiceList = (data = {}) => HttpService.get("/api/v2/sysCarrierGroup/findList", { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP });
// 获取所有物流产品服务
export const HttpGetAllServiceProductList = (data = {}) => HttpService.get("/api/v2/carrierGroupServiceCode/findAllByContextId", { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP });
// 获取所有承运商服务
export const HttpGetProductServiceByOrg = (data = {}) => HttpService.get('/api/v2/sysCarrierService/findList', { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP })
// 获取所有承运商
export const HttpGetProductByOrg = (data = {}) => HttpService.get('/api/v2/sysCarrier/findList', { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP })
// 获取客户有效物流产品服务
export const HttpGetCustomServiceProductActiceList = (data = {}) => HttpService.get('/api/v2/carrierGroupServiceCode/bossFindByCustomerId', { params: { ...data, customerId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_SHIP })
// 获取客户全部物流产品服务
export const HttpGetCustomServiceProductAllList = (data = {}) => HttpService.get('/api/v2/carrierGroupServiceCode/findAllByCustomerId', { params: { ...data, customerId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_SHIP })
// 获取客户有效物流产品
export const HttpGetCustomServiceActiveList = (data = {}) => HttpService.get('/api/v2/sysCarrierGroup/findByCustomerId', { params: { ...data, customerId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_SHIP })
// 获取客户全部物流产品
export const HttpGetCustomServiceAllList = (data = {}) => HttpService.get('/api/v2/sysCarrierGroup/findAllByCustomerId', { params: { ...data, customerId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_SHIP })
//获取账期
export const HttpGetPaymentDays = (data = {}) => HttpService.get('/api/v2/newBilling/billPeriod/findByOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//获取账单
export const HttpGetBillNumber = (data = {}) => HttpService.get('/api/v2/newBilling/bill/findByPeriodAndOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//重新结算（附加费）
export const HttpRecountSave = (data = {}) => HttpService.post('/api/v2/freightSettlement/reSettlementAddonRule', data,  {baseURL: process.env.VUE_APP_APIURL_FBB})